import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
  Divider
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import palette from 'src/theme/palette';
import useMediaQuery from '@mui/material/useMediaQuery';

const PrivacyPolicyViewModal = ({ open, onClose, policy }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  if (!policy) return null;

  // Function to safely render HTML content
  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          maxHeight: isMobile ? '100vh' : '90vh',
          // width: isMobile ? '100vw' : '1000px',
          margin: isMobile ? 0 : undefined
        }
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          background: palette.primary.main,
          color: palette.primary.contrastText,
          py: 2,
          px: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          zIndex: 1
        }}
      >
        <Typography
          sx={{
            fontSize: 20,
            fontFamily: 'poppinsSemiBold',
            color: palette.primary.contrastText
          }}
        >
          View Privacy Policy
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: palette.primary.contrastText,
            '&:hover': {
              backgroundColor: palette.primary.dark
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3 }}>
          {policy.contents &&
            policy.contents.map((content, index) => (
              <Box key={content.id || index} sx={{ mb: 3 }}>
                {/* Content */}
                <Box
                  sx={{
                    borderRadius: 1,
                    p: 2,
                    backgroundColor: palette.background.neutral,
                    border: `1px solid ${palette.primary.inputborder}`
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={createMarkup(content.paragraph)}
                    style={{
                      fontFamily: 'poppinsRegular',
                      fontSize: '14px',
                      lineHeight: '1.6',
                      color: palette.text.primary
                    }}
                  />
                </Box>

                {/* Add divider between content items except for the last one */}
                {index < policy.contents.length - 1 && <Divider sx={{ my: 2 }} />}
              </Box>
            ))}

          {(!policy.contents || policy.contents.length === 0) && (
            <Typography
              sx={{
                textAlign: 'center',
                color: palette.text.secondary,
                fontFamily: 'poppinsRegular',
                py: 4
              }}
            >
              No content available
            </Typography>
          )}
        </Box>
      </DialogContent>

      {/* Footer Buttons */}
      <DialogActions sx={{ p: 3, gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderColor: palette.primary.inputborder,
            color: palette.primary.title,
            '&:hover': {
              borderColor: palette.primary.main,
              backgroundColor: palette.primary.hover
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyViewModal;
